import {api} from "@/api";

// 获取项目树
export const getProjectListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/projectLocal/getTree',
        method: 'POST',
        data: data
    })
}


// 保存项目列表
export const saveProjectListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/projectLocal/saveLocal',
        method: 'POST',
        data: data
    })
}

// 删除项目列表
export const delProjectListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/projectLocal/delete',
        method: 'POST',
        data: data
    })
}

// 获取绑定该项目的设备列表
export const getDeviceListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/projectLocal/pageEquipment',
        method: 'POST',
        data: data
    })
}


// *******************************************************************************************************
// 获取未绑定项目设备
export const getAllDeviceListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/equipmentLocal/page',
        method: 'POST',
        data: data
    })
}
// 绑定设备
export const bindDeviceListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/equipmentLocal/bind',
        method: 'POST',
        data: data
    })
}
// 解绑设备
export const removeDeviceListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/equipmentLocal/unbind',
        method: 'POST',
        data: data
    })
}


// 仪表盘设置---------------------------------------------------------------------
// 获取仪表盘选项
export const getCustomSelectApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/panel/listParamSelect',
        method: 'POST',
        data: data
    })
}
// 获取图表选项
export const getChatSelectApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/panel/listQuerySelect',
        method: 'POST',
        data: data
    })
}
// 获取仪表盘详情
export const getCustomDetailApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        // url: '/zouk/rest/panel/getDetail',
        url: '/zouk/message/rest/panel/getData',
        method: 'POST',
        data: data
    })
}

// 更新仪表盘
export const saveCustomDetailApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/panel/save',
        method: 'POST',
        data: data
    })
}